import { useCallback } from 'react';

import { encodeRovoParams } from '@atlassian/conversation-assistant-pubsub';

import { getAtlasURL } from '../../common/utils/atlas-url';

export const useAgentUrlActions = ({ siteId }: { siteId: string }) => {
	const onEditAgent = useCallback(
		(agentId: string) => {
			window.open(
				getAtlasURL(siteId, `/chat/agents/${agentId}/edit`),
				'_blank',
				'noopener, noreferrer',
			);
		},
		[siteId],
	);

	const onCopyAgent = useCallback(
		(agentId: string) => {
			const rovoParams = encodeRovoParams({
				pathway: 'chat',
				agentId: agentId,
			});
			navigator.clipboard.writeText(getAtlasURL(siteId, `/chat?${rovoParams}`));
		},
		[siteId],
	);

	const onDuplicateAgent = useCallback(
		(agentId: string) => {
			const rovoParams = encodeRovoParams({
				pathway: 'agents-create',
				agentId: agentId,
			});
			window.open(
				getAtlasURL(siteId, `/chat/agents/new?${rovoParams}`),
				'_blank',
				'noopener, noreferrer',
			);
		},
		[siteId],
	);

	return {
		onEditAgent,
		onCopyAgent,
		onDuplicateAgent,
	};
};
